import React, { } from "react";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
} from "@chakra-ui/react";
// Components
import CommonButton from "../button/button";

const ModalConfirmYesNo = ({ 
  title, 
  description, 
  isOpen, 
  onClose, 
  handleClose, 
  isCentered = false, 
  children = null,
  yesButtonCaption = null,
  noButtonCaption = null,
  yesButtonDisabled = false,
}) => {
  const cancelRef = React.useRef();

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={() => {
        handleClose(false);
        onClose();
      }}
      isCentered={isCentered}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {title}
          </AlertDialogHeader>

          <AlertDialogBody>{!!children ? children : description}</AlertDialogBody>

          <AlertDialogFooter>
            <CommonButton
              onClick={() => {
                handleClose(true);
                onClose();
              }}
              disabled={yesButtonDisabled}
              style={{
                width: "100px",
              }}
            >
              {!!yesButtonCaption ? yesButtonCaption : "Si"}
            </CommonButton>
            <CommonButton
              ref={cancelRef}
              onClick={() => {
                handleClose(false);
                onClose();
              }}
              inverted={true}
              style={{ 
                width: "100px",
                marginLeft: "5px"
              }}
            >
              {!!noButtonCaption ? noButtonCaption : "No"}
            </CommonButton>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export default ModalConfirmYesNo;
